import { observable } from '@legendapp/state';
import { ObservablePersistLocalStorage } from '@legendapp/state/persist-plugins/local-storage';
import { syncObservable } from '@legendapp/state/sync';

type StoreState = {
  discountTimer: {
    targetTime: number;
    hasStarted: boolean;
  };
};

export const store$ = observable<StoreState>({
  discountTimer: {
    targetTime: Date.now() + 60 * 1000,
    hasStarted: false,
  },
});

syncObservable(store$.discountTimer, {
  persist: {
    name: 'youth-discount-timer',
    plugin: ObservablePersistLocalStorage,
  },
});

export const setDiscountTimer = (minutes: number = 5): void => {
  const hasStarted = store$.discountTimer.hasStarted.get();

  if (!hasStarted) {
    const now = Date.now();
    const newTargetTime = now + minutes * 60 * 1000;
    store$.discountTimer.targetTime.set(newTargetTime);
    store$.discountTimer.hasStarted.set(true);
  }
};

export const getDiscountTimer = () => store$.discountTimer.targetTime.get();
